import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import FilterPopup from "../FilterPopup";

interface Props {
  title: string
  onApply: () => void
  minHeight: number
  width: number
  open: boolean
  onOpen: () => void
  onClose: () => void
}

const MultiPickerFilterPopup = (props: React.PropsWithChildren<Props>) => {
  return <FilterPopup
    filterButtonLabel={props.title}
    content={<div
      style={{ minHeight: props.minHeight, maxHeight: 500 }}
      className="flex-column gap"
    >

      {props.children}

      <ButtonPrimary
        onClick={props.onApply}
        label={RESX.SelectionManager.Apply}
      />
    </div>}
    width={props.width}
    open={props.open}
    onClose={props.onClose}
    onOpen={props.onOpen}
  />;
};

export default MultiPickerFilterPopup;